import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Stream } from '../models/stream';

@Injectable({
  providedIn: 'root'
})
export class StreamService {

  constructor(
    private _http: HttpClient
  ) { }

  public getDiscount(code:string, ids:any):Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/streamDiscount/'+code+'/'+ids).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public logDiscountUse(code:string):Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/logStreamDiscount', {code:code}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getStream(stream_id): Observable<Stream> {
    return this._http.get<Stream>(environment.apiEndpoint + `/api/stream-full/${stream_id}`).pipe(
      map(res => {
        return res;
      })
    );
  }

  public getPopularStreams(): Observable<Stream[]> {
    return this._http.get<Stream[]>(environment.apiEndpoint + '/api/streams/popular').pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public getPopularStreamsWithMeta(): Observable<Stream[]> {
    return this._http.get<Stream[]>(environment.apiEndpoint + '/api/streams/popularWithMeta').pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public getTutorStreams(tutorId:number, loggedIn:boolean=false):Observable<any>{
    if (loggedIn) {
      return this._http.get(environment.apiEndpoint+'/api/streams/tutorWithMeta/'+tutorId).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    } else {
      return this._http.get(environment.apiEndpoint+'/api/streams/tutor/'+tutorId).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }
  }

  public getSupporterStreams(supporterId:number, loggedIn:boolean=false):Observable<any>{
    if (loggedIn) {
      return this._http.get(environment.apiEndpoint+'/api/streams/supporterWithMeta/'+supporterId).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    } else {
      return this._http.get(environment.apiEndpoint+'/api/streams/supporter/'+supporterId).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }
  }
}
